import { Stack, Button, ButtonGroup, Panel, Tabs, Placeholder } from 'rsuite';
import "./Tabs.scss";


const CustomTabs = ({ tabsData, activeTab, setActiveTab }: any) => {
    return (
        <Panel>
            <Tabs className='btn-text gap-0' activeKey={activeTab} onSelect={setActiveTab} appearance='pills'>
                {tabsData.map((item: any) => (
                    <Tabs.Tab key={item?.id} eventKey={item?.key} title={item?.title} />
                ))}
            </Tabs>


        </Panel>
    )
}

export default CustomTabs;
